import React from 'react'
import Router from '../router'

interface Props {
    router: Router
    organization: string
}

export class RequestHistory extends React.PureComponent<Props> {
    public render() {
        return (
            <a
                className="tw-font-size-14 btn btn-default btn-xs"
                style={{ float: 'right' }}
                data-remote-modal
                href={'/settings/organizations/request-stats-modal?organization=' + this.props.organization}
                onClick={ev => {
                    ev.preventDefault()

                    const $modal = jQuery('#selector-modal-nofade')

                    // @ts-ignore
                    let url = ev.target.href

                    if (url === undefined) {
                        url = $(ev.target)
                            .closest('a')
                            .attr('href')
                    }

                    jQuery.ajax({
                        url,
                        success: data => {
                            // @ts-ignore
                            $modal.html(data).modal('toggle')
                            $modal
                                .find('[data-billing-request-stats]')
                                // @ts-ignore
                                .billingRequestStats()
                        },
                    })
                }}
            >
                <i className="fa fa-bar-chart"></i> Request History
            </a>
        )
    }
}
